import { Reveal, PageHero, SectionHeading, CTABand, ICONS } from "@/components/Common";
import { INDUSTRIES } from "@/data/site";

const Industries = () => (
  <>
    <PageHero
      crumb="Home — Industries We Serve"
      title="Industries We Serve"
      subtitle="Dependable manpower and managed services for government, institutional, commercial and industrial establishments."
    />
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Sectors"
          title="Wherever Dependable Manpower Is Required"
          desc="Our deployments span government institutions, healthcare, education, corporate, hospitality, retail, industrial and residential environments."
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ICONS[ind.icon];
            return (
              <Reveal key={ind.name} delay={(i % 4) * 0.06}>
                <div
                  className="group border border-slate-200 bg-[#FAFAFC] p-7 h-full text-center transition-all hover:bg-navy hover:border-navy hover:-translate-y-1 hover:shadow-xl hover:shadow-navy/20"
                  data-testid={`industry-${ind.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <div className="w-12 h-12 bg-gold-soft flex items-center justify-center mx-auto transition-colors group-hover:bg-gold">
                    <Icon size={22} className="text-gold-hover transition-colors group-hover:text-navy" />
                  </div>
                  <p className="mt-5 text-sm font-semibold text-navy transition-colors group-hover:text-white">{ind.name}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
    <CTABand
      title="Don't see your industry listed?"
      desc="If your organization requires outsourced manpower, security or facility support — talk to us. We structure solutions around your requirement."
    />
  </>
);

export default Industries;
